import { useMemo } from "react";
import { formatDistanceToNow } from "date-fns";
import { ptBR } from "date-fns/locale";
import { Cartao, Titulo, TituloAcoes, Conteudo, Rotulo, ValorDestacado, Timestamp } from "../styles";
import { IconRecusada, IconClock } from "../../../icons/IconesSistema";
import { IconUser } from "../../../icons";
import { 
  RodapeRecusa,
  RodapeContainer,
  AvatarContainer,
  InfoContainer,
  NomeContainer,
  NomeProfissional,
  CodigoProfissional
} from "./styles";
import { comum } from "../../../../styles/Themes/light";

const formatarDataRelativa = (data: string | Date | null | undefined): string => {
  if (!data) return "";
  try {
    const dataFormatada = new Date(data);
    if (Number.isNaN(dataFormatada.getTime())) return "";
    return formatDistanceToNow(dataFormatada, { 
      addSuffix: true, 
      locale: ptBR 
    });
  } catch (error) {
    return "";
  }
};

export default function RecusaEntregaDemanda({ demanda }: any) {
  const historicoRecusa = useMemo(() => {
    if (!demanda?.historico || !Array.isArray(demanda.historico)) return null;
    return demanda.historico
      .filter((h: any) => {
        const acao = (h.acao || "").toLowerCase();
        return acao.includes('demanda recusada') || acao.includes('recusou');
      })
      .sort((a: any, b: any) => {
        const dataA = new Date(a.criado || 0).getTime();
        const dataB = new Date(b.criado || 0).getTime();
        return dataB - dataA;
      })?.[0];
  }, [demanda?.historico]);

  const mensagem = demanda?.justificativa?.trim() ? demanda.justificativa : "--";
  const nomeOperador = historicoRecusa?.nome_responsavel || demanda?.nome_operador?.trim() || "";
  const idOperador = historicoRecusa?.id_responsavel || demanda?.id_operador;
  const dataRelativa = formatarDataRelativa(historicoRecusa?.criado);
  
  const codigoFormatado = idOperador ? `P${idOperador}` : "";
  const temIdentificacao = nomeOperador || codigoFormatado;

  return (
    <Cartao>
      <Titulo>
        <IconRecusada size={18} color="#E52940" />
        Recusa da entrega da demanda
        {dataRelativa && (
          <TituloAcoes>
            <Timestamp>
              <IconClock size={14} />
              {dataRelativa}
            </Timestamp>
          </TituloAcoes>
        )}
      </Titulo>
      <Conteudo>
        {temIdentificacao && (
          <RodapeRecusa>
            <RodapeContainer>
              <AvatarContainer>
                <IconUser color={comum.colors.primaryRed400} size={20} />
              </AvatarContainer>
              <InfoContainer>
                <NomeContainer>
                  {nomeOperador ? (
                    <>
                      <NomeProfissional>{nomeOperador}</NomeProfissional>
                      {codigoFormatado && <CodigoProfissional>{codigoFormatado}</CodigoProfissional>}
                    </>
                  ) : codigoFormatado ? (
                    <NomeProfissional>{codigoFormatado}</NomeProfissional>
                  ) : null}
                </NomeContainer>
              </InfoContainer>
            </RodapeContainer>
          </RodapeRecusa>
        )}

        <Rotulo>Mensagem da recusa</Rotulo>
        <ValorDestacado>{mensagem}</ValorDestacado>
      </Conteudo>
    </Cartao>
  );
}

